import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Thermometer, Snowflake, Refrigerator, Zap, Droplets, Wrench, Star } from 'lucide-react';

const ServicesSection = () => {
  const navigate = useNavigate();

  const services = [
    { id: 'kombi', name: 'Kombi Servisi', icon: Thermometer, color: 'from-orange-500 to-red-500', pros: '247', rating: '4.9' },
    { id: 'klima', name: 'Klima Servisi', icon: Snowflake, color: 'from-blue-500 to-cyan-500', pros: '189', rating: '4.8' },
    { id: 'beyaz_esya', name: 'Beyaz Eşya', icon: Refrigerator, color: 'from-teal-500 to-emerald-500', pros: '312', rating: '4.7' },
    { id: 'elektrik', name: 'Elektrik', icon: Zap, color: 'from-yellow-500 to-amber-500', pros: '178', rating: '4.9' },
    { id: 'su_tesisati', name: 'Su Tesisatı', icon: Droplets, color: 'from-cyan-500 to-blue-500', pros: '156', rating: '4.6' },
    { id: 'genel', name: 'Diğer', icon: Wrench, color: 'from-gray-500 to-slate-600', pros: '98', rating: '4.5' },
  ];

  const popularSearches = [
    { name: 'Kombi Bakımı', id: 'kombi' },
    { name: 'Demirdöküm Servis', id: 'kombi' },
    { name: 'Baymak Servis', id: 'kombi' },
    { name: 'Vaillant Servis', id: 'kombi' },
    { name: 'Klima Montaj', id: 'klima' },
    { name: 'Klima Gazı Dolumu', id: 'klima' },
    { name: 'Split Klima', id: 'klima' },
    { name: 'Buzdolabı Tamiri', id: 'beyaz_esya' },
    { name: 'Çamaşır Makinesi', id: 'beyaz_esya' },
    { name: 'Bulaşık Makinesi', id: 'beyaz_esya' },
    { name: 'Fırın Tamiri', id: 'beyaz_esya' },
    { name: 'Elektrik Arızası', id: 'elektrik' },
    { name: 'Priz Montajı', id: 'elektrik' },
    { name: 'Aydınlatma', id: 'elektrik' },
    { name: 'Su Kaçağı', id: 'su_tesisati' },
    { name: 'Tıkanıklık Açma', id: 'su_tesisati' },
    { name: 'Petek Temizleme', id: 'su_tesisati' },
    { name: 'Termosifon', id: 'su_tesisati' },
  ];

  return (
    <section className="py-10 md:py-14 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">Tüm Hizmetlerimiz</h2>
          <p className="text-gray-500 text-sm md:text-base">İhtiyacınıza uygun hizmeti seçin, hemen teklif alın</p>
        </div>
        
        {/* Ana Kategori Kartları */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5 mb-10">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <button
                key={service.id}
                onClick={() => navigate(`/servis-talep/${service.id}`)}
                className="group bg-white rounded-2xl p-4 md:p-5 border border-gray-100 hover:border-[#006D77] hover:shadow-xl transition-all duration-300 text-center"
                data-testid={`popular-${service.id}`}
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform shadow-lg`}>
                  <Icon className="w-7 h-7 md:w-8 md:h-8 text-white" />
                </div>
                <h3 className="font-bold text-gray-900 text-sm md:text-base mb-1 group-hover:text-[#006D77] transition-colors">{service.name}</h3>
                <div className="flex items-center justify-center gap-2 text-xs text-gray-500">
                  <span>{service.pros} usta</span>
                  <span className="flex items-center gap-0.5">
                    <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
                    {service.rating}
                  </span>
                </div>
              </button>
            );
          })}
        </div>

        {/* Popüler Aramalar */}
        <div className="bg-white rounded-2xl border border-gray-100 p-6 md:p-8">
          <h3 className="text-lg font-bold text-gray-900 mb-5 text-center">Popüler Aramalar</h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {popularSearches.map((item, idx) => (
              <button
                key={idx}
                onClick={() => navigate(`/servis-talep/${item.id}`)}
                className="bg-gray-50 hover:bg-[#006D77] text-gray-600 hover:text-white px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border border-gray-200 hover:border-[#006D77]"
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
        
        <div className="text-center mt-8">
          <Button
            onClick={() => navigate('/hizmetler')}
            variant="outline"
            className="border-2 border-[#006D77] text-[#006D77] hover:bg-[#006D77] hover:text-white px-8 py-3 rounded-full font-semibold"
          >
            Tüm Hizmetleri Gör
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
